import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { GuestRoute, ProtectedRoute } from './guards/RouteGuards';
import { AdminRealtimeProvider } from './context/AdminRealtimeContext';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import MenuItems from './pages/MenuItems';
import { MenuItemFormRoute } from './pages/MenuItemForm';
import Orders from './pages/Orders';
import OrderHistory from './pages/OrderHistory';
import OrderDetail from './pages/OrderDetail';
import PaymentHistory from './pages/PaymentHistory';
import PaymentDetail from './pages/PaymentDetail';
import Reviews from './pages/Reviews';
import Feedback from './pages/Feedback';
import SupportTickets from './pages/SupportTickets';
import SupportTicketDetail from './pages/SupportTicketDetail';
import Rewards from './pages/Rewards';
import RewardForm from './pages/RewardForm';
import Banners from './pages/Banners';
import AppUsers from './pages/AppUsers';
import AppUserDetail from './pages/AppUserDetail';
import Metadata from './pages/Metadata';
import LegalPages from './pages/LegalPages';
import CommissionBreakdown from './pages/CommissionBreakdown';
import Analytics from './pages/Analytics';

export default function App() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <GuestRoute>
            <Login />
          </GuestRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <GuestRoute>
            <ForgotPassword />
          </GuestRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <GuestRoute>
            <ResetPassword />
          </GuestRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute>
            <AdminRealtimeProvider>
              <AppLayout />
            </AdminRealtimeProvider>
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="categories" element={<Categories />} />
        <Route path="menu-items" element={<Outlet />}>
          <Route index element={<MenuItems />} />
          <Route path="new" element={<MenuItemFormRoute />} />
          <Route path=":menuItemId" element={<MenuItemFormRoute />} />
        </Route>
        <Route path="orders" element={<Orders />} />
        <Route path="order-history" element={<OrderHistory />} />
        <Route path="orders/:orderId" element={<OrderDetail />} />
        <Route path="payments" element={<PaymentHistory />} />
        <Route path="payments/:paymentId" element={<PaymentDetail />} />
        <Route path="reviews" element={<Reviews />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="support-tickets" element={<SupportTickets />} />
        <Route path="support-tickets/:ticketId" element={<SupportTicketDetail />} />
        <Route path="banners" element={<Banners />} />
        <Route path="rewards" element={<Rewards />} />
        <Route path="rewards/new" element={<RewardForm />} />
        <Route path="rewards/:rewardId" element={<RewardForm />} />
        <Route path="app-users" element={<AppUsers />} />
        <Route path="app-users/:userId" element={<AppUserDetail />} />
        <Route path="metadata" element={<Metadata />} />
        <Route path="legal-pages" element={<LegalPages />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="commission-breakdown/:orderKey" element={<CommissionBreakdown />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
